import {AfterViewInit, Component} from '@angular/core';
declare const $;
declare const g_Controls: any;

@Component({
    selector: 'app-data',
    templateUrl: './data.component.html',
    styleUrls: ['./data.component.css'],
    standalone: false
})
export class DataReportComponent implements AfterViewInit
{
  public useHistoryJsonRawData = false;
  public currentTab: string = "rawdata_info"

  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "Data" }));
    setTimeout(() => this.syncRawDataColumnMode(), 0);
  }

  public onRawDataColumnModeChange(): void {
    this.syncRawDataColumnMode();
  }

  private syncRawDataColumnMode(): void {
    const control = g_Controls?.["rawdatacontrol"];
    if (control && typeof control.SetDataColumnMode === "function")
      control.SetDataColumnMode(this.useHistoryJsonRawData);
  }

  public openTabTrackingRight(tabName: string, headNum: number) {
    var x = $(".rightreport .tabpage");
    this.currentTab = tabName;
    for (var i = 0; i < x.length; i++)
      $(x[i]).addClass("hidden");

    $("#" + tabName).removeClass("hidden");

    x = $(".righttrack .btn_tabs button");
    for (var i = 0; i < x.length; i++)
      $(x[i]).removeClass("active");
    $(x[headNum - 1]).addClass("active");

    //$(window).trigger('resize');
  }

}
